webpackJsonp([35783957827783],{

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  margin-top: 3.5rem;\n  margin-bottom: 3.5rem;\n'], ['\n  display: flex;\n  flex-direction: column;\n  margin-top: 3.5rem;\n  margin-bottom: 3.5rem;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  position: relative;\n  text-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);\n  margin-bottom: 0.75rem;\n  @media ', ' {\n    font-size: 2rem;\n  }\n  @media ', ' {\n    font-size: 2.5rem;\n  }\n'], ['\n  position: relative;\n  text-shadow: 0 12px 30px rgba(0, 0, 0, 0.15);\n  margin-bottom: 0.75rem;\n  @media ', ' {\n    font-size: 2rem;\n  }\n  @media ', ' {\n    font-size: 2.5rem;\n  }\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n  position: absolute;\n  font-size: 7rem;\n  transform: translate(-50%, -50%);\n  opacity: 0.08;\n  user-select: none;\n  z-index: -1;\n'], ['\n  position: absolute;\n  font-size: 7rem;\n  transform: translate(-50%, -50%);\n  opacity: 0.08;\n  user-select: none;\n  z-index: -1;\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n  grid-column: -1 / 1;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n'], ['\n  grid-column: -1 / 1;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _kebabCase = __webpack_require__(100);
	
	var _kebabCase2 = _interopRequireDefault(_kebabCase);
	
	var _media = __webpack_require__(18);
	
	var _Subline = __webpack_require__(40);
	
	var _Subline2 = _interopRequireDefault(_Subline);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Post = _styledComponents2.default.article(_templateObject);
	
	var Title = _styledComponents2.default.h1(_templateObject2, _media.media.phone, _media.media.tablet);
	
	var Initiale = _styledComponents2.default.span(_templateObject3);
	
	var Excerpt = _styledComponents2.default.p(_templateObject4);
	
	var Article = function Article(_ref) {
	  var title = _ref.title,
	      date = _ref.date,
	      excerpt = _ref.excerpt,
	      slug = _ref.slug,
	      timeToRead = _ref.timeToRead,
	      category = _ref.category;
	
	  var firstChar = title.charAt(0);
	
	  return _react2.default.createElement(
	    Post,
	    null,
	    _react2.default.createElement(
	      Title,
	      null,
	      _react2.default.createElement(
	        Initiale,
	        null,
	        firstChar
	      ),
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: slug },
	        title
	      )
	    ),
	    _react2.default.createElement(
	      _Subline2.default,
	      null,
	      date,
	      ' : ',
	      timeToRead,
	      ' Min Read : In\xA0',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/categories/' + (0, _kebabCase2.default)(category) },
	        category
	      )
	    ),
	    _react2.default.createElement(
	      Excerpt,
	      null,
	      excerpt
	    )
	  );
	};
	
	exports.default = Article;
	module.exports = exports['default'];

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  background-size: cover;\n  background-image: ', ';\n'], ['\n  background-size: cover;\n  background-image: ', ';\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: 1.5rem;\n  padding: 1em 2.5em;\n  text-align: right;\n  color: ', ';\n  @media ', ' {\n    font-size: 1.2rem;\n  }\n  @media ', ' {\n    font-size: 1.3rem;\n  }\n'], ['\n  font-size: 1.5rem;\n  padding: 1em 2.5em;\n  text-align: right;\n  color: ', ';\n  @media ', ' {\n    font-size: 1.2rem;\n  }\n  @media ', ' {\n    font-size: 1.3rem;\n  }\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _media = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var HeroDiv = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.backgroundImage;
	});
	
	var Title = _styledComponents2.default.h1(_templateObject2, function (props) {
	  return props.theme.bg;
	}, _media.media.phone, _media.media.tablet);
	
	var Hero = function Hero(props) {
	  return _react2.default.createElement(
	    HeroDiv,
	    {
	      backgroundImage: 'url("' + props.heroImage.childImageSharp.sizes.src + '")',
	      style: {
	        maxWidth: props.width,
	        maxHeight: props.height,
	        height: props.height
	      }
	    },
	    _react2.default.createElement(
	      Title,
	      null,
	      props.children
	    )
	  );
	};
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  font-size: ', ';\n  color: ', ';\n  ', ';\n  ', ';\n  ', ';\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n'], ['\n  font-size: ', ';\n  color: ', ';\n  ', ';\n  ', ';\n  ', ';\n  display: flex;\n  justify-content: flex-start;\n  flex-wrap: wrap;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Line = _styledComponents2.default.div(_templateObject, function (props) {
	  return props.theme.fontSmall;
	}, function (props) {
	  return props.theme.light;
	}, function (props) {
	  return props.sectionTitle && 'margin-top: -3rem';
	}, function (props) {
	  return props.sectionTitle && 'margin-bottom: 4rem';
	}, function (props) {
	  return props.sectionTitle && 'text-align: center';
	});
	
	var Subline = function Subline(props) {
	  return _react2.default.createElement(
	    Line,
	    { sectionTitle: props.sectionTitle },
	    props.children
	  );
	};
	
	exports.default = Subline;
	module.exports = exports['default'];

/***/ }),

/***/ 291:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WindowSizeRP = function (_React$Component) {
	  _inherits(WindowSizeRP, _React$Component);
	
	  function WindowSizeRP(props) {
	    _classCallCheck(this, WindowSizeRP);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleResize = _this.handleResize.bind(_this);
	    _this.state = {
	      hasComputed: false,
	      width: 0,
	      height: 0
	    };
	    return _this;
	  }
	
	  WindowSizeRP.prototype.componentDidMount = function componentDidMount() {
	    this.setState(_extends({}, this.getDimensions(this.props), {
	      hasComputed: true
	    }));
	    window.addEventListener('resize', this.handleResize, false);
	  };
	
	  WindowSizeRP.prototype.componentWillReceiveProps = function componentWillReceiveProps(next) {
	    this.setState(this.getDimensions(next));
	  };
	
	  WindowSizeRP.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.removeEventListener('resize', this.handleResize, false);
	  };
	
	  WindowSizeRP.prototype.getDimensions = function getDimensions() {
	    return {
	      width: window.innerWidth,
	      height: window.innerHeight
	    };
	  };
	
	  WindowSizeRP.prototype.handleResize = function handleResize() {
	    var _this2 = this;
	
	    this.setState({
	      hasComputed: false
	    }, function () {
	      _this2.setState(_extends({
	        hasComputed: true
	      }, _this2.getDimensions(_this2.props)));
	    });
	  };
	
	  WindowSizeRP.prototype.render = function render() {
	    return this.props.render(this.state);
	  };
	
	  return WindowSizeRP;
	}(_react2.default.Component);
	
	exports.default = WindowSizeRP;
	module.exports = exports['default'];

/***/ }),

/***/ 295:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.IndexQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  grid-column: 2;\n  box-shadow: 0 4px 120px rgba(0, 0, 0, 0.1);\n  border-radius: 1rem;\n  padding: 2rem 4rem;\n  margin-top: 1em;\n  @media ', ' {\n    padding: 3rem 2rem;\n  }\n  @media ', ' {\n    padding: 2rem 1.5rem;\n  }\n  overflow: hidden;\n'], ['\n  grid-column: 2;\n  box-shadow: 0 4px 120px rgba(0, 0, 0, 0.1);\n  border-radius: 1rem;\n  padding: 2rem 4rem;\n  margin-top: 1em;\n  @media ', ' {\n    padding: 3rem 2rem;\n  }\n  @media ', ' {\n    padding: 2rem 1.5rem;\n  }\n  overflow: hidden;\n']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(8);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _Article = __webpack_require__(110);
	
	var _Article2 = _interopRequireDefault(_Article);
	
	var _Wrapper = __webpack_require__(41);
	
	var _Wrapper2 = _interopRequireDefault(_Wrapper);
	
	var _Hero = __webpack_require__(290);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _WindowSizeRP = __webpack_require__(291);
	
	var _WindowSizeRP2 = _interopRequireDefault(_WindowSizeRP);
	
	var _SiteConfig = __webpack_require__(17);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _media = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Content = _styledComponents2.default.div(_templateObject, _media.media.tablet, _media.media.phone);
	
	var IndexPage = function IndexPage(props) {
	  var postEdges = props.data.allMarkdownRemark.edges;
	  var heroImage = postEdges[postEdges.length - 1].node.frontmatter.cover;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_WindowSizeRP2.default, {
	      render: function render(sizing) {
	        return _react2.default.createElement(
	          _Hero2.default,
	          _extends({}, sizing, { heroImage: heroImage }),
	          _SiteConfig2.default.siteTitle
	        );
	      }
	    }),
	    _react2.default.createElement(
	      _Wrapper2.default,
	      null,
	      _react2.default.createElement(
	        Content,
	        null,
	        postEdges.map(function (post) {
	          return _react2.default.createElement(_Article2.default, {
	            title: post.node.frontmatter.title,
	            date: post.node.frontmatter.date,
	            excerpt: post.node.excerpt,
	            timeToRead: post.node.timeToRead,
	            slug: post.node.fields.slug,
	            category: post.node.frontmatter.category,
	            key: post.node.fields.slug
	          });
	        })
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	
	/* eslint no-undef: off */
	
	var IndexQuery = exports.IndexQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-071e048c77a3f77330e1.js